const AgentFaqContent = [
  {
    title: "What is Lighter Advisory?",
    content:
      "Lighter Advisory is a real estate advisory primarily focused on creating a delightful customer experience. We walk with you through the entire journey of finding, exploring and buying or renting the perfect property as per your needs.",
  },

  {
    title: "Why Lighter Advisory?",
    content:
      "Lighter Advisory connects real estate clients by creating a powerful professional network. We leverage our connections with real estate experts, strategist, developers, agents and professionals to simplify real estate transactions. We tap the power of tools like social media, digital marketing, portals and community to maximize the reach of your properties.",
  },

  {
    title: "I am an agent. How can Lighter Advisory help me?",
    content:
      "At Lighter Advisory, we believe that alliances and partnership in the real estate market is the only way we can grow, not only as business entities but also as a united realty community. Lighter Advisory collaborates with agents in the real estate industry and provides referrals and clients for agent sourced properties. Lighter Advisory has properties in all segments and locations of the market, so we also work with clients sent by agents on a transaction partnership model. The Lighter Advisory platform has property seekers looking for residential, commercial, industrial, warehousing and agricultural properties. At Lighter Advisory, we motivate and engage our professional channel partners to create more value for the properties we market. We work with channel partners whose ideals and methods are aligned with the company strategy and business.",
  },

  {
    title: "How to register as an agent?",
    content:
      "You can call or WhatsApp us at +91 99807 75599, mail us at mail@Lighter Advisory.com or follow this link.",
  },

  {
    title:
      "How can I post my property or requirements on Lighter Advisory platform?",
    content:
      "After registering with us as an agent, Call us and send us the details of the property or your client requirement. You can also upload the property details on our website and we will get back to you regarding your property or client requirement.",
  },

  {
    title:
      "Will real estate agents be charged for posting properties on Lighter Advisory?",
    content:
      "We do not charge anyone for using our technology platform. In the future, we may charge a license fee for registered verified users of our platform.",
  },

  {
    title: "How is the commission split between real estate agents?",
    content:
      "The commission will be based on a scenario-based approach. Based on the transaction, we will update you the commission that we will pay out and the legal terms in advance.",
  },

  {
    title:
      "Can Lighter Advisory help me with registering as a RERA certified real estate agent?",
    content: "Yes, we can. Call us for details.",
  },
];

export default AgentFaqContent;
